import { SparkAreaChart } from '@tremor/react';

export interface SparklinePoint {
  date: string; // ISO or any string the chart uses as the X axis
  value: number;
}

interface Props {
  data: SparklinePoint[];
  loading?: boolean;
  empty?: string;
  className?: string;
  color?: string;
}

export function Sparkline({
  data,
  loading,
  empty = 'sem dados',
  className = '',
  color = 'blue',
}: Props) {
  if (loading) {
    return (
      <div
        className={`h-10 w-full animate-pulse rounded bg-slate-800/40 ${className}`}
        role="status"
        aria-label="Carregando..."
      />
    );
  }
  if (!data || data.length === 0) {
    return (
      <div className={`text-xs text-slate-500 ${className}`}>{empty}</div>
    );
  }
  return (
    <div className={className}>
      <SparkAreaChart
        data={data}
        index="date"
        categories={['value']}
        colors={[color]}
        className="h-10 w-full"
      />
    </div>
  );
}
